import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { clamp } from '@/shared/lib/math/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'CProgressLinear',
  props: {
    value: {
      default: 0
    },
    backgroundColor: {
      default: undefined
    },
    color: {
      default: undefined
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var resolvedValue = computed(function () {
      if (props.value == null) {
        return '0%';
      }
      var asNumber = Number(props.value);
      if (isNaN(asNumber)) {
        return '0%';
      }
      return "".concat(clamp(asNumber, 0, 100), "%");
    });
    var variables = computed(function () {
      return {
        '--progress-background-color': props.backgroundColor || undefined,
        '--progress-foreground-color': props.color || undefined,
        '--value': resolvedValue.value
      };
    });
    return {
      __sfc: true,
      props: props,
      resolvedValue: resolvedValue,
      variables: variables
    };
  }
});